function addToCart($form, widget) {
  let variant_id = 0;
  if($form.find('#product-select').length > 0) {
    variant_id = $form.find('#product-select').val();
  } else if($form.find('.js-product-item-select').length > 0) {
    variant_id = $form.find('.js-product-item-select').val();
  }
  let qty = 1;
  if($form.find('#product-quantity').length > 0) {
    qty = $form.find('#product-quantity').val();
  }

  let params = {
    quantity: qty,
    id: variant_id
  };

  if($form.find('#has_pz').length > 0 && window.PZ_SELECTIONED != null && window.PZ_VARIANT_ID != '') {
    let properties = {},
        value = '';

    properties['Style Code'] = window.PZ_SELECTIONED[0].style_desc;
    properties[window.PZ_FEE_PRODUCT.title] = '$' + window.PZ_SELECTIONED[0].price;

    let price = Math.ceil(window.PZ_SELECTIONED[0].price * 100);
    let variant_id = 0;

    window.PZ_FEE_PRODUCT.variants.forEach(function (item) {
      if(price == item.price) {
        variant_id = item.id;
      }
    });
    properties['_pz_fee_variant_id'] = variant_id;

    let pz_selectioned = window.PZ_SELECTIONED;
    pz_selectioned.forEach(function(item, index){
      delete item.id
      delete item.shop_id
      delete item.instruct_text

      let line_cnts = window.PZ_SELECTIONED.length;
      let key_surfix = '';
      if(line_cnts > 1) {
        let new_index = index + 1;
        key_surfix = ' ' + new_index;
      }
      properties['Line' + key_surfix] = 'Line Type: ' + item.line_type + ' | Value: ' + item.value

    });

    params['properties'] = properties;
  } else if($form.find('#has_pz').length > 0 && window.PZ_STYLECODE != '') {
    let properties = {};
    let pz_noselection = window.PZ_NOSELECTION;
    
    delete pz_noselection.id
    delete pz_noselection.shop_id
    delete pz_noselection.price
    delete pz_noselection.instruct_text
    delete pz_noselection.value

    properties['Style Code'] = window.PZ_STYLECODE;
    properties[window.PZ_FEE_PRODUCT.title] = '$0.00';
    properties['Line Type'] = pz_noselection.line_type;
    properties['Value'] = pz_noselection.line_type;
    params['properties'] = properties;
  }

  $.ajax({
    url: '/cart/add.js',
    dataType: 'json',
    data: params,
    success: function(result) {
      if($form.find('#has_pz').length > 0 && window.PZ_SELECTIONED != null && window.PZ_VARIANT_ID != '') {
        addCartPZ($form, widget, qty);
      } else {
        ajaxCart(widget);
      }
    },
    error: function(error) {
      if ($form.find('.js-product-message').length) {
        $form.find('.js-product-message').removeClass('hidden');
      } else {
        alert(error.responseJSON.description);
      }
    }
  });
}

function addCartPZ($form, widget, qty) {
  let price = Math.ceil(window.PZ_SELECTIONED[0].price * 100);
  let variant_id = 0;

  window.PZ_FEE_PRODUCT.variants.forEach(function (item) {
    if(price == item.price) {
      variant_id = item.id;
    }
  });

  let params = {
    quantity: qty,
    id: variant_id
  };

  $.ajax({
    url: '/cart/add.js',
    dataType: 'json',
    data: params,
    success: function(result) {
      ajaxCart(widget);
    },
    error: function(error) {
      if ($form.find('.js-product-message').length) {
        $form.find('.js-product-message').removeClass('hidden');
      } else {
        alert(error.responseJSON.description);
      }
    }
  });
}

function updateCartGift(itemsArray, widget) {
  $.post('/cart/update.js', {
    updates: itemsArray
  }).done(function() {
    if (widget) {
      ajaxCart(widget);
    } else {
      ajaxCart();
    }
  }).fail(function(error) {
    alert(error.responseJSON.description);
  })
}

function updateCart($form, widget, href) {
  if (href == undefined) {
    $.ajax({
      url: '/cart/update.js',
      dataType: 'json',
      data: $form.serialize(),
      success: function(result) {
        if (widget) {
          ajaxCart(widget);
        } else {
          ajaxCart();
        }
      },
      error: function(error) {
        alert(error.responseJSON.description);
      }
    });
  } else {
    $.post('/cart/update.js', 'updates[' + href + ']=0').done(function() {
      if (widget) {
        ajaxCart(widget);
      } else {
        ajaxCart();
      }
    });
  }
}

function ajaxCart(widget) {
  $.ajax({
    url: '/cart',
    success: function(data) {
      if (widget) {
        const html = $(data).find('.widget-cart-container .widget__container').html();
        const total = $(data).find('.cart-global-total span');
        const $widgetCart = $('.js-widget-cart');

        if ($widgetCart.length) {
          $widgetCart.find('.widget__container').html(html);

          $widgetCart.addClass('expanded');
        };
        
        $('.js-btn-cart span').html(total);
      } else {
        const total = $(data).find('.cart-global-total span');
        const $section = $('.js-section-cart');

        if ($section.length) {
          const sectionHead = $($(data).find('.js-section-cart .section__head').html());
          const formBody = $($(data).find('.js-section-cart .form__body').html());
          const formFoot = $($(data).find('.js-section-cart .form__foot-aside').html());
          const $formEmpty = $($(data).find('.js-section-cart .form__empty'));

          $section.find('.section__head').html(sectionHead);
          $section.find('.form__body').html(formBody);
          $section.find('.form__foot-aside').html(formFoot);

          if ($formEmpty.length) {
            $formEmpty.insertBefore($section.find('.form__body'));
          };
        };
        
        $('.js-btn-cart span').html(total);
      }
    }
  });
}

module.exports = {
  addToCart,
  updateCartGift,
  updateCart,
  ajaxCart
};



// WEBPACK FOOTER //
// ../assets/js/ajax-cart.js